import { render, staticRenderFns } from "./DocumentInsertionPurchaseOrder.vue?vue&type=template&id=2754c9fe&"
import script from "./DocumentInsertionPurchaseOrder.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionPurchaseOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports